// Centralized data-testid registry for OGO Notary site
export const NAV = {
  brand: "nav-brand",
  home: "nav-home",
  about: "nav-about",
  signingAgent: "nav-signing-agent",
  mobile: "nav-mobile-notary",
  ron: "nav-ron",
  pricing: "nav-pricing",
  faq: "nav-faq",
  contact: "nav-contact",
  mobileToggle: "nav-mobile-toggle",
  mobilePanel: "nav-mobile-panel",
};

export const HOME = {
  hero: "home-hero",
  heroHeadline: "home-hero-headline",
  heroSubheadline: "home-hero-subheadline",
  bookBtn: "home-book-appointment-btn",
  learnMoreBtn: "home-learn-more-btn",
  serviceMobileCard: "service-card-mobile",
  serviceLoanCard: "service-card-loan",
  serviceRonCard: "service-card-ron",
  trustBanner: "home-trust-banner",
  faqAccordion: "home-faq-accordion",
  emergentLink: "home-emergent-link",
};

export const CONTACT = {
  form: "contact-form",
  fullName: "contact-full-name",
  email: "contact-email",
  phone: "contact-phone",
  service: "contact-service",
  serviceTrigger: "contact-service-trigger",
  preferredDate: "contact-preferred-date",
  preferredTime: "contact-preferred-time",
  message: "contact-message",
  submit: "contact-submit-btn",
  successAlert: "contact-success-alert",
  errorAlert: "contact-error-alert",
};

export const FOOTER = {
  root: "site-footer",
  legal: "footer-legal",
  privacy: "footer-privacy-link",
  terms: "footer-terms-link",
  disclaimer: "footer-disclaimer",
};

export const VENDOR = {
  hero: "vendor-hero",
  ctaHeader: "vendor-cta-header",
  ctaSigning: "vendor-cta-signing",
  ctaHome: "vendor-cta-home",
  form: "vendor-form",
  companyName: "vendor-company-name",
  contactName: "vendor-contact-name",
  role: "vendor-role",
  roleTrigger: "vendor-role-trigger",
  email: "vendor-email",
  phone: "vendor-phone",
  website: "vendor-website",
  coverage: "vendor-coverage",
  volume: "vendor-volume",
  volumeTrigger: "vendor-volume-trigger",
  notes: "vendor-notes",
  submit: "vendor-submit-btn",
  successAlert: "vendor-success-alert",
  errorAlert: "vendor-error-alert",
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",
  dashboard: "admin-dashboard",
  logout: "admin-logout-btn",
  tabContacts: "admin-tab-contacts",
  tabVendors: "admin-tab-vendors",
  tabLeads: "admin-tab-leads",
  search: "admin-search-input",
  filter: "admin-filter-select",
  filterTrigger: "admin-filter-trigger",
  refresh: "admin-refresh-btn",
  exportCsv: "admin-export-csv-btn",
  contactsTable: "admin-contacts-table",
  vendorsTable: "admin-vendors-table",
  leadsTable: "admin-leads-table",
  empty: "admin-empty-state",
};
